/**
 * Define specific contexts here - events, conferences, etc...
 *
 * For EthCC 2025 we used context 'ethcc'.
 * Best is to add some sort of a timestamp so we don't repeat contexts, as these are stored in localStorage
 * e.g. 'ethcc26' for EthCC 2026
 */
export const CONTEXTS: string[] = [];
